import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { Grid, InputBase, IconButton } from '@material-ui/core';
import { Send as SendIcon } from '@material-ui/icons';
import { ru } from 'locale';
import useStyles from './MessageInput.styles';

const MessageInput = forwardRef(function MessageInput(props, ref) {
  const { value, onChange, onSend } = props;
  const classes = useStyles();

  const handleSend = () => {
    if (value.length > 0) {
      onSend();
    }
  };

  return (
    <footer ref={ref}>
      <Grid container>
        <Grid item xs>
          <InputBase value={value} rowsMax={6} onChange={onChange} fullWidth multiline />
        </Grid>

        <Grid item className={classes.actions} zeroMinWidth>
          <IconButton edge="end" color="inherit" aria-label={ru.sendMessage} onClick={handleSend}>
            <SendIcon />
          </IconButton>
        </Grid>
      </Grid>
    </footer>
  );
});

MessageInput.propTypes = {
  value: Type.string.isRequired,
  onChange: Type.func.isRequired,
  onSend: Type.func.isRequired,
};

export default MessageInput;
